import { EventTriggerFixed } from '@user-portal/wikr-analytics';

import { trackEventFixed } from './mainTrackers';

export const sendAnalyticEmailUpdate = () => {
    trackEventFixed({ event: EventTriggerFixed.emailUpdateSuccess });
};

export const sendAnalyticPasswordUpdate = () => {
    trackEventFixed({ event: EventTriggerFixed.passwordUpdateSuccess });
};

export const sendAnalyticProfileUpdateSuccess = (updatedFields: string[]) => {
    trackEventFixed({ event: EventTriggerFixed.profileUpdateSuccess, eventLabel: updatedFields });
};

export const sendAnalyticProfileUpdateError = () => {
    trackEventFixed({ event: EventTriggerFixed.profileUpdateError });
};
